import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {PasswordExpiryEnum} from './password-expiry-key.enum';
import {PasswordExpiry} from './services/password-expiry.service';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '@drl/core/auth/auth.service';
import {ToastrService} from 'ngx-toastr';
import {environment} from '@drl/env/environment';

@Component({
  selector: 'app-password-expiry-popup',
  templateUrl: './password-expiry-popup.component.html',
  styleUrls: ['./password-expiry-popup.component.scss'],
})
export class PasswordExpiryPopupComponent implements OnInit {
  @Input() passwordExpiry: PasswordExpiry;
  @Output() closeAlert = new EventEmitter<void>();
  constructor(
    private readonly translateSvc: IpsTranslateService,
    private readonly authService: AuthService,
    private readonly toastrService: ToastrService,
  ) {
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  prePasswordExpiryMsg: string;
  postPassowrdExpiryMsg: string;
  confirmPasswordMsg: string;
  prePasswordExpiryDesc: string;
  postPassowrdExpiryDesc: string;
  confirmPasswordDesc: string;
  resetNowLbl: string;
  resetLaterLbl: string;
  okLbl: string;
  loading = true;
  buttonLoading = false;
  sdaysLbl: string;
  sdayLbl: string;

  ngOnInit() {
    this.loading = true;
    this.getTranslations();
    this.loading = false;
  }
  getTranslations() {
    this.loading = true;
    if (
      this.passwordExpiry &&
      this.passwordExpiry.expiryType === PasswordExpiryEnum.PrePasswordExpired
    ) {
      this.loading = true;
      this.translate
        .get([
          'prePasswordExpiryDesc',
          'resetNowLbl',
          'resetLaterLbl',
          'sdaysLbl',
          'sdayLbl',
        ])
        .subscribe(
          res => {
            const today = 0;
            const oneDay = 1;
            this.prePasswordExpiryDesc = res.prePasswordExpiryDesc;
            this.resetNowLbl = res.resetNowLbl;
            this.resetLaterLbl = res.resetLaterLbl;
            this.sdayLbl = res.sdayLbl;
            this.sdaysLbl = res.sdaysLbl;
            switch (this.passwordExpiry.days) {
              case today:
                this.prePasswordExpiryMsg = this.translate.instant(
                  'todayPasswordExpiryMsg',
                );
                break;
              case oneDay:
                this.prePasswordExpiryMsg = this.translate.instant(
                  'prePasswordExpiryMsg',
                  {
                    days: oneDay,
                    daysLbl: this.sdayLbl,
                  },
                );
                break;
              default:
                this.prePasswordExpiryMsg = this.translate.instant(
                  'prePasswordExpiryMsg',
                  {
                    days: this.passwordExpiry.days,
                    daysLbl: this.sdaysLbl,
                  },
                );
            }
            this.loading = false;
          },
          err => {
            this.loading = false;
          },
        );
    } else if (
      this.passwordExpiry &&
      this.passwordExpiry.expiryType ===
        PasswordExpiryEnum.ResetPasswordConfirmation
    ) {
      this.loading = true;
      this.translate
        .get(['confirmPasswordMsg', 'confirmPasswordDesc', 'okLbl'])
        .subscribe(
          res => {
            this.confirmPasswordMsg = res.confirmPasswordMsg;
            this.confirmPasswordDesc = res.confirmPasswordDesc;
            this.okLbl = res.okLbl;
            this.loading = false;
          },
          err => {
            this.loading = false;
          },
        );
    } else if (
      this.passwordExpiry &&
      this.passwordExpiry.expiryType === PasswordExpiryEnum.PostPasswordExpired
    ) {
      this.loading = true;
      // in this prePassoerdExpiryDesc using in postExpiry as want the content which required after postExpiryDesc
      this.translate
        .get([
          'postPassowrdExpiryMsg',
          'postPassowrdExpiryDesc',
          'resetNowLbl',
          'prePasswordExpiryDesc',
        ])
        .subscribe(
          res => {
            this.postPassowrdExpiryMsg = res.postPassowrdExpiryMsg;
            this.postPassowrdExpiryDesc = res.postPassowrdExpiryDesc;
            this.resetNowLbl = res.resetNowLbl;
            this.prePasswordExpiryDesc = res.prePasswordExpiryDesc;
            this.loading = false;
          },
          err => {
            this.loading = false;
          },
        );
    } else {
      // do nothing
    }
  }
  passwordResetNow() {
    this.buttonLoading = true;
    this.authService.sendExpiryResetEmail().subscribe(
      res => {
        this.passwordExpiry.expiryType =
          PasswordExpiryEnum.ResetPasswordConfirmation;
        this.getTranslations();
        this.buttonLoading = false;
      },
      err => {
        this.toastrService.error(
          this.translateSvc.translate.instant('errorMsgLbl'),
          this.translateSvc.translate.instant('errorLbl'),
          {
            timeOut: environment.messageTimeout,
          },
        );
        this.buttonLoading = false;
      },
    );
  }

  closePopup() {
    this.closeAlert.emit();
  }

  logoutClosePopup() {
    this.authService.logout();
    this.closeAlert.emit();
  }
}
